import React, { useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import format from "date-fns/format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

interface DateSelectionRange {
  startDate: Date;
  endDate: Date;
  key: string;
}

export const DateRange: React.FC<{
  startDate: string;
  endDate: string;
  setDates: (s: string, e: string) => void;
}> = ({ startDate, endDate, setDates }) => {
  const [SelectedDates, setSelectedDates] = useState<DateSelectionRange>({
    startDate: new Date(startDate),
    endDate: new Date(endDate),
    key: "selection",
  });

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleSelect = (ranges: any) => {
    const selection = ranges?.selection;

    if (selection?.startDate && selection?.endDate) {
      setSelectedDates({
        startDate: selection.startDate,
        endDate: selection.endDate,
        key: "selection",
      });

      setDates(
        moment(selection.startDate).format("YYYY-MM-DD"),
        moment(selection.endDate).format("YYYY-MM-DD"),
      );
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Button
        aria-describedby={id}
        variant="outlined"
        style={{ color: "#fff", borderColor: "#fff" }}
        onClick={handleClick}
      >
        <FontAwesomeIcon
          size="1x"
          style={{ marginRight: 8 }}
          icon={faCalendarAlt}
        />
        {format(SelectedDates.startDate, "PP")} -{" "}
        {format(SelectedDates.endDate, "PP")}
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <DateRangePicker ranges={[SelectedDates]} onChange={handleSelect} />
      </Popover>
    </>
  );
};
